export const ORDER_ITEMS_KEY = 'item';
export const ORDER_REQUEST_ID_KEY = 'orderRequestId';
export const ORDER_SUBMITTED_KEY = 'orderSubmittedRequestId';
export const ORDER_DATA_TEMP_KEY = 'dataTemp';
export const ORDER_TICKET_TYPE_KEY = 'orderTicketType';

const createRequestId = (): string => {
  const cryptoObj:
    | {
        randomUUID?: () => string;
        getRandomValues?: (arr: Uint8Array) => Uint8Array;
      }
    | undefined =
    typeof window !== 'undefined' ? (window as any)?.crypto : undefined;
  if (typeof cryptoObj?.randomUUID === 'function') {
    return cryptoObj.randomUUID();
  }

  const bytes = new Uint8Array(16);
  if (typeof cryptoObj?.getRandomValues === 'function') {
    cryptoObj.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 16; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  /* eslint-disable no-bitwise */
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10x
  /* eslint-enable no-bitwise */
  let hex = '';
  for (let i = 0; i < 16; i += 1) {
    hex += (bytes[i] + 0x100).toString(16).slice(1);
  }
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(
    12,
    16,
  )}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

export const setOrderItems = (items: unknown): string => {
  const requestId = createRequestId();
  try {
    sessionStorage.setItem(ORDER_ITEMS_KEY, JSON.stringify(items));
    sessionStorage.setItem(ORDER_REQUEST_ID_KEY, requestId);
    const ticketType = sessionStorage.getItem('ticketType');
    if (ticketType) sessionStorage.setItem(ORDER_TICKET_TYPE_KEY, ticketType);
    else sessionStorage.removeItem(ORDER_TICKET_TYPE_KEY);
  } catch {}
  return requestId;
};

export const getOrderTicketType = (): string | null => {
  try {
    return sessionStorage.getItem(ORDER_TICKET_TYPE_KEY);
  } catch {
    return null;
  }
};

export const getOrderRequestId = (): string => {
  try {
    const existing = sessionStorage.getItem(ORDER_REQUEST_ID_KEY);
    if (existing) return existing;
    const created = createRequestId();
    sessionStorage.setItem(ORDER_REQUEST_ID_KEY, created);
    return created;
  } catch {
    return createRequestId();
  }
};

export const markOrderSubmitted = (requestId: string) => {
  try {
    sessionStorage.setItem(ORDER_SUBMITTED_KEY, requestId);
  } catch {}
};

export const clearOrderSubmitted = () => {
  try {
    sessionStorage.removeItem(ORDER_SUBMITTED_KEY);
  } catch {}
};

export const hasPendingOrderSubmit = (): boolean => {
  try {
    const submitted = sessionStorage.getItem(ORDER_SUBMITTED_KEY);
    if (!submitted) return false;
    return submitted === sessionStorage.getItem(ORDER_REQUEST_ID_KEY);
  } catch {
    return false;
  }
};

export const clearOrderSession = () => {
  try {
    sessionStorage.removeItem(ORDER_ITEMS_KEY);
    sessionStorage.removeItem(ORDER_REQUEST_ID_KEY);
    sessionStorage.removeItem(ORDER_SUBMITTED_KEY);
    sessionStorage.removeItem(ORDER_DATA_TEMP_KEY);
    sessionStorage.removeItem(ORDER_TICKET_TYPE_KEY);
  } catch {}
};

export const hasOrderSession = (): boolean => {
  try {
    const items = JSON.parse(sessionStorage.getItem(ORDER_ITEMS_KEY) as string);
    const dataTemp = JSON.parse(
      sessionStorage.getItem(ORDER_DATA_TEMP_KEY) as string,
    );
    return (
      Array.isArray(items) &&
      items.length > 0 &&
      Array.isArray(dataTemp) &&
      dataTemp.length > 0
    );
  } catch {
    return false;
  }
};
